import React from 'react'
import logo from '../../assets/images/wrric.png'

export default function FallbackPage() {
    return (
        <>
            <div className="side_bg d-flex justify-content-center align-items-center">
                <div className="text-white text-center">
                    <img src={logo} alt="lg" className="img-fluid zoom-animation" style={{ height: '100px' }} />
                </div>
            </div>
        </>
    )
}
